import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { useIntl } from 'umi';

import FreeIcon from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import VideoIcon from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import Xbox from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import SourceSteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import GamalyticIcon from '@/pages/intelligence/assets/svg/dataSource/gamalytic.svg';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

export const useMobileOptionList = (params: any = {}) => {
  const { asForDate } = params;
  const { formatMessage } = useIntl();

  const rpdListTopchart = [
    {
      title: formatMessage({ id: 'dbi_metric_rpd_asfor' }, { time: asForDate }),
      key: 'rpd',
      textContent: 'dbi_info_rpd_cumulative',
      width: 275,
      width_cn: 320,
      metricKey: 'rpd'
    },
    {
      title: formatMessage({ id: `dbi_metric_cumulative_revenue` }),
      key: 'revenue',
      textContent: `dbi_info_sum_selected`,
      width: 320,
      width_cn: 215,
      metricKey: 'cumulative_revenue'
    },
    {
      title: formatMessage({ id: `dbi_metric_cumulative_downloads` }),
      key: 'download',
      textContent: `dbi_info_sum_selected`,
      width: 250,
      width_cn: 190,
      metricKey: 'cumulative_downloads'
    },
  ];

  //用于详情（与榜单的key不同，key用于取后端值）
  const rpdListDetail = [
    {
      title: formatMessage({ id: 'dbi_metric_rpd_asfor' }, { time: asForDate }),
      key: 'rpd',
      textContent: 'dbi_info_rpd_cumulative',
      width: 275,
      width_cn: 320,
      metricKey: 'rpd'
    },
    {
      title: formatMessage({ id: `dbi_metric_cumulative_revenue` }),
      key: 'cumulative_revenue',
      textContent: `dbi_info_sum_selected`,
      width: 240,
      width_cn: 180,
      metricKey: 'cumulative_revenue'
    },
    {
      title: formatMessage({ id: `dbi_metric_cumulative_downloads` }),
      key: 'cumulative_downloads',
      textContent: `dbi_info_sum_selected`,
      width: 230,
      width_cn: 120,
      metricKey: 'cumulative_downloads'
    },
  ];

  const rpdSegementOptions = [
    { text: 'RPD($)', value: 'rpd' },
    {
      text: formatMessage({ id: `dbi_metric_cumulative_revenue` }),
      value: 'cumulative_revenue',
    },
    {
      text: formatMessage({ id: `dbi_metric_cumulative_downloads` }),
      value: 'cumulative_downloads',
    },
  ];

  const rpdSegementTitleObj: { [key: string]: any } = {
    rpd: 'RPD',
    cumulative_revenue: formatMessage({ id: `dbi_metric_cumulative_revenue` }),
    cumulative_downloads: formatMessage({
      id: `dbi_metric_cumulative_downloads`,
    }),
  } as any;

  const potentialSourceSteamPCU = {
    title: formatMessage({ id: `dbi_metric_source_steam_pcu` }),
    key: 'source_steam__pcu',
    sortMetric: 'source_steam__pcu',
    svgIcon: SourceSteamIcon,
    isNoDropdown: false,
    dataSource: 'source_steam',
    textContent: `dbi_info_source_steam_pcu`,
    width: 220,
  };

  const potentialSteamPCU = {
    title: formatMessage({ id: `dbi_metric_gamalytic_steam_pcu` }),
    key: 'gamalytic__pcu',
    sortMetric: 'gamalytic__pcu',
    svgIcon: GamalyticIcon,
    isNoDropdown: false,
    dataSource: 'gamalytic',
    textContent: `dbi_info_pcu`,
    width: 220,
  };

  const potentialSteamTopWishLists = [
    {
      // title: 'Top Wish List',
      title: formatMessage({ id: `dbi_store_rank_top_wish_lists` }),
      key: 'steam top wish lists',
      sortMetric: 'steam top wish lists',
      svgIcon: SteamIcon,
      isNoDropdown: false,
      dataSource: 'steam',
      textContent: `dbi_info_steam_topwishlists`,
      width: 200,
    },
    {
      title: formatMessage({ id: `dbi_metric_steam_followers` }),
      key: 'steamfollowers',
      sortMetric: 'steamfollowers',
      svgIcon: SteamIcon,
      isNoDropdown: false,
      dataSource: 'steam',
      textContent: `dbi_info_steamfollowers`,
      width: 230,
    },
  ];

  const potentialXboxUpcoming = {
    title: formatMessage({ id: `dbi_xbox_upcoming` }),
    key: 'xbox upcoming',
    sortMetric: 'xbox upcoming',
    svgIcon: Xbox,
    isNoDropdown: false,
    dataSource: 'xbox',
    textContent: `dbi_info_xbox_upcoming`,
    width: 230,
  };

  const potentialPlaystationComingSoon = {
    title: formatMessage({ id: `dbh_storerank_comingsoon` }),
    key: 'playstation coming soon',
    sortMetric: 'playstation coming soon',
    svgIcon: getDataSourceIcon('playstationbalck'),
    isNoDropdown: false,
    dataSource: 'playstation',
    textContent: `dbh_storerank_comingsoon`,
    width: 210,
  };

  const potentialSteamNewAndTrending = {
    // title: 'New and Trending',
    title: formatMessage({ id: `dbi_store_rank_new_and_trending` }),
    key: 'steam new and trending',
    sortMetric: 'steam new and trending',
    svgIcon: SteamIcon,
    isNoDropdown: false,
    dataSource: 'steam',
    textContent: `dbi_info_steam_newtrending`,
    width: 240,
    width_cn: 220,
  };
  const potentialXboxNewRelease = {
    // title: 'New Release',
    title: formatMessage({ id: `dbi_store_rank_new_release` }),
    key: 'xbox new release',
    sortMetric: 'xbox new release',
    svgIcon: Xbox,
    isNoDropdown: false,
    dataSource: 'xbox',
    textContent: `dbi_info_xbox_newrelease`,
    width: 200,
  };
  const potentialNewGamesNewRelease = {
    title: formatMessage({ id: `dbh_storerank_newgames` }),
    key: 'playstation new games',
    sortMetric: 'playstation new games',
    svgIcon: getDataSourceIcon('playstationbalck'),
    isNoDropdown: false,
    dataSource: 'playstation',
    textContent: `dbh_storerank_newgames`,
    width: 180,
  };
  const potentialNewReleaseMetrics = [
    {
      // title: 'Top Free(#1-10)',
      title: formatMessage({ id: `dbi_store_rank_top_free` }) + '(#1-10)',
      key: 'appstore top free',
      sortMetric: 'appstore top free',
      svgIcon: FreeIcon,
      isNoDropdown: false,
      dataSource: 'appstore',
      textContent: `dbi_info_appstore_topfree`,
      width: 200,
    },
    {
      // title: 'Top Grossing(#1-10)',
      title: formatMessage({ id: `dbi_store_rank_top_grossing` }) + '(#1-10)',
      key: 'appstore top grossing',
      sortMetric: 'appstore top grossing',
      svgIcon: FreeIcon,
      isNoDropdown: false,
      dataSource: 'appstore',
      textContent: `dbi_info_appstore_topgrossing`,
      width: 240,
    },
    {
      // title: 'Top Free(#1-10)',
      title: formatMessage({ id: `dbi_store_rank_top_free` }) + '(#1-10)',
      key: 'googleplay top free',
      sortMetric: 'googleplay top free',
      svgIcon: VideoIcon,
      isNoDropdown: false,
      dataSource: 'googleplay',
      textContent: `dbi_info_googleplay_topfree`,
      width: 200,
    },
    {
      // title: 'Top Grossing(#1-10)',
      title: formatMessage({ id: `dbi_store_rank_top_grossing` }) + '(#1-10)',
      key: 'googleplay top grossing',
      sortMetric: 'googleplay top grossing',
      svgIcon: VideoIcon,
      isNoDropdown: false,
      dataSource: 'googleplay',
      textContent: `dbi_info_googleplay_topgrossing`,
      width: 240,
    },
  ];

  return {
    rpdListTopchart,
    rpdListDetail,
    rpdSegementOptions,
    rpdSegementTitleObj,
    potentialSourceSteamPCU,
    potentialSteamPCU,
    potentialSteamTopWishLists,
    potentialXboxUpcoming,
    potentialSteamNewAndTrending,
    potentialXboxNewRelease,
    potentialNewReleaseMetrics,
    potentialPlaystationComingSoon,
    potentialNewGamesNewRelease,
  };
};
